export enum IpRestrictionRadio {
  Enabled = 'enabled',
  Disabled = 'disabled',
}

export type IpRestrictionRadioValue =
  (typeof IpRestrictionRadio)[keyof typeof IpRestrictionRadio];

export const ipRestrictionFromApiBoolean = (
  isIpAddressRestrictionEnabled: boolean
): IpRestrictionRadioValue =>
  isIpAddressRestrictionEnabled
    ? IpRestrictionRadio.Enabled
    : IpRestrictionRadio.Disabled;

export const ipRestrictionToApiBoolean = (
  value: IpRestrictionRadioValue
): boolean => value === IpRestrictionRadio.Enabled;
